import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  loadDatasetBrowserData,
  updatePersonalSearchTerm,
  updateWorkspaceSearchTerm,
  loadDatasetDataWithSearch,
} from './datasets.actions';
import {
  selectWorkspaceDatasetBrowserData,
  selectPersonalPagination,
  selectWorkspacePagination,
  selectPersonalDatasetBrowserData,
  selectWorkspaceSearchTerm,
  selectPersonalSearchTerm,
  selectDatasetsPagination,
  selectDatasetBrowserData,
} from './datasets.selectors';

interface LoadDatasetParams {
  org: string;
  datasetType: string;
  pageNum: number;
  searchTerm: string;
  tabType: string;
}

@Injectable({ providedIn: 'root' })
export class DatasetsFacade {
  personalDatasetPagination$ = this.store.select(selectPersonalPagination);
  workspaceDatasetPagination$ = this.store.select(selectWorkspacePagination);
  personalDatasetBrowserData$ = this.store.select(selectPersonalDatasetBrowserData);
  workspaceDatasetBrowserData$ = this.store.select(selectWorkspaceDatasetBrowserData);
  workspaceSearchTerm$ = this.store.select(selectWorkspaceSearchTerm);
  personalSearchTerm$ = this.store.select(selectPersonalSearchTerm);

  datasetPagination$ = this.store.select(selectDatasetsPagination);

  constructor(private store: Store) {}

  datasetBrowserData$ = this.store.select(selectDatasetBrowserData);

  loadDatasetBrowserData(params: LoadDatasetParams, isSearch = false): void {
    const action = isSearch ? loadDatasetDataWithSearch : loadDatasetBrowserData;
    this.store.dispatch(action(params));
  }

  updateWorkspaceSearchTerm(searchTerm: string): void {
    this.store.dispatch(updateWorkspaceSearchTerm({ searchTerm }));
  }

  updatePersonalSearchTerm(searchTerm: string): void {
    this.store.dispatch(updatePersonalSearchTerm({ searchTerm }));
  }
}
